export const CUSTOM_POPUP_OPEN = 'OTT/customPopup/CUSTOM_POPUP_OPEN';
export const CUSTOM_POPUP_CLOSE = 'OTT/customPopup/CUSTOM_POPUP_CLOSE';
